// extracted by mini-css-extract-plugin
module.exports = {"field":"BooleanField_field__2mask","isChecked":"BooleanField_isChecked__28GB_"};